export const changeAba = (event) => {
  return {
    type: "CHANGE_ABA",
    payload: event,
  };
};

export const changeAbaNew = (event) => {
  return {
    type: "CHANGE_ABA_NEW",
    payload: event,
  };
};

export const changeAbaNode = (event) => {
  return {
    type: "CHANGE_ABA_NODE",
    payload: event,
  };
};
